<mar-navbar>
	@if (user$ | async; as user) {
		@if ({ open: false }; as state) {
			<button
				appearance="ghost"
				tuiButton
				class="flex gap-3 items-center text-left hover:bg-primary-300 focus-visible:bg-primary-300"
				[tuiDropdown]="menu"
				[(tuiDropdownOpen)]="state.open"
			>
				<span [tuiAvatar]="user | userInitials" size="s"></span>

				<span class="mt-1 leading-5 font-semibold">
					<p class="p-0 m-0 leading-3 text-white">
						{{ user | name }}
					</p>
					<small class="p-0 m-0 text-xs text-primary-700">
						{{ user.email }}
					</small>
				</span>

				<tui-icon
					size="s"
					class="text-white transition-transform duration-300"
					[class.rotate-180]="state.open"
					icon="@tui.chevron-down"
				/>

				<ng-template #menu let-close>
					<div
						class="flex items-center gap-1 flex-col p-4 bg-primary-900 relative"
					>
						<span
							[tuiAvatar]="user | userInitials"
							size="m"
							class="mb-2"
							appearance="primary"
						></span>

						<p class="font-semibold">
							{{ user | name }}
						</p>

						<p class="text-xs text-primary">
							{{ user.email }}
						</p>

						@if (user.role === 'admin') {
							<span
								tuiBadge
								appearance="accent"
								class="!absolute top-2 right-2 !text-accent !bg-accent-300 !border-accent-300"
								iconStart="@tui.star"
								[tuiHint]="'user.role.' + user.role | transloco"
							></span>
						}
					</div>

					<tui-data-list>
						<tui-opt-group>
							@for (item of menuItems(); track item) {
								<button
									tuiOption
									type="button"
									(click)="state.open = false; item.handler()"
								>
									<tui-icon [icon]="item.iconStart" />

									<span>{{ item.label | transloco }}</span>

									@if (item.iconEnd) {
										<tui-icon [icon]="item.iconEnd" />
									}
								</button>
							}

							<div
								class="flex items-center justify-end px-2 py-2"
							>
								<p class="text-gray-300 font-semibold text-xs">
									{{ 'app.version' | transloco: { version } }}
								</p>
							</div>
						</tui-opt-group>
					</tui-data-list>
				</ng-template>
			</button>
		}
	}
</mar-navbar>

<!-- Navigation tabs below navbar -->
@if (user$ | async; as user) {
	<nav class="flex justify-start bg-primary-900 px-8">
		<tui-tabs tuiMainTabs>
			<a
				tuiTab
				routerLinkActive="active"
				routerLink="/analysis"
				iconStart="@tui.chart-line"
			>
				{{ 'navigation.analyses' | transloco }}
			</a>

			@if (user | isAdmin) {
				<a
					tuiTab
					routerLinkActive="active"
					routerLink="/report"
					iconStart="@tui.clipboard-list"
				>
					{{ 'navigation.report-dashboard' | transloco }}
				</a>
			}

			@if (leadership.canAccessOrganizations()) {
				<a
					tuiTab
					routerLinkActive="active"
					routerLink="/organization"
					iconStart="@tui.building-2"
				>
					{{ 'navigation.organizations' | transloco }}
				</a>
			}

			@if (leadership.canAccessGroups()) {
				<a
					tuiTab
					routerLinkActive="active"
					routerLink="/group"
					iconStart="@tui.layers"
				>
					{{ 'navigation.groups' | transloco }}
				</a>
			}
		</tui-tabs>
	</nav>
}

<!-- 64px is the height of the navbar -->
<main
	class="flex-grow flex-shrink-0 flex flex-col h-[calc(100%-104px)] overflow-scroll"
>
	<router-outlet />
</main>
